import { Box, Button, Card, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../type/Label';
import CustomIcon from './CustomIcon';
import { captilizeString } from '../functionUtils';
import { analyticsTrackEvent } from '../../../utils/analytics/analytics-utils';
import {
  getPriorAuthorization, setPriorAuthClean, 
} from '../../../redux/priorAuth/action';

const PriorAuthorizations = () => {
  const dispatch = useDispatch();

  const [memberList, setMemberList] = useState([]);
  // const [noAuthorizationMessage, setNoAuthorizationMessage] = useState('');
  const memberAccounts = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails
  );
  const priorAuthError = useSelector(state => state?.priorAuth?.error);
  const priorAuth = useSelector(state => state?.priorAuth?.priorAuth);
    useEffect(()=> {
      dispatch(setPriorAuthClean());

    }, []);
  useEffect(() => {
    if (priorAuth && priorAuth.length > 0) {
      // Create a Blob from the base64 data
      const byteCharacters = atob(priorAuth);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      // Create a data URL from the Blob
      const url = URL.createObjectURL(blob);

      // Open the URL in a new tab
      window.open(url, '_blank');

      // Release the object URL after a delay (you can adjust the delay)
      // setTimeout(() => {
      //   URL.revokeObjectURL(url);
      // }, 1000);
      return ()=> {
        URL.revokeObjectURL(url);
        dispatch(setPriorAuthClean());
      };
    }
  }, [priorAuth]);

  useEffect(() => {
    if (memberAccounts?.self || memberAccounts?.dependents)
      memberAccounts?.self
        ? setMemberList([
            { ...memberAccounts.self },
            ...memberAccounts.dependents
          ])
        : setMemberList([null, ...memberAccounts.dependents]);
  }, [memberAccounts]);

  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  const PriorAuthorizationsConfig =
    tenantLayouts.BenefitsPriorAuthorizationsMainLayout
      .PriorAuthorizationsConfig;
  const getPriorAuth = (groupId, subscriberId, subscriberSuffix, index) => {
    const { self: selfFromStore } = memberAccounts;
    let memberAccountHeader = '';
    if (selfFromStore || memberAccounts?.dependents.length) {
      memberAccountHeader = `${groupId}-${subscriberId}-${subscriberSuffix}`;
    }
    dispatch(
      getPriorAuthorization(
        memberAccountHeader,
        localStorage.getItem('tenantHandle'),
        index
      )
    );

  };

  return (
    <Box className="priorAuthSection">
      <Container className="priorAuthCards">
      {memberList.length === 0 || !memberList[0]?.firstName ? 
          <Card className="no-prior-Auth-Card">
          <Typography variant="h6">
            No prior authorizations to display.
          </Typography>
        </Card> : (memberList.map((member, index) => {
            return (
              <React.Fragment key={index}>
                <Card className="priorAuthCard">
                  <div>
                    <Typography
                      variant="h6"
                      className="priorAuthName"
                      color="defualt"
                    >
                      {`${captilizeString(member?.firstName)} ${captilizeString(
                        member?.lastName
                      )}`}
                    </Typography>
                  </div>
                  <div className='priorAuthBTN'>
                    <Button
                      variant="outlined"
                      color="secondary"
                      id={'btn-' + member?.firstName}
                      onClick={e => {
                        e.preventDefault();
                        analyticsTrackEvent('prior_auth_viewed', {
                          eventCategory: 'Plan Benefits Pathing'
                        });
                        getPriorAuth(
                          member?.groupId,
                          member?.subscriberId,
                          member?.subscriberSuffix, index
                        );
                      }}
                    >
                      <CustomIcon
                        iconName={PriorAuthorizationsConfig.buttonIcon}
                      />{' '}
                      <Label id="subnavPriorAuthorizations"/>
                      {/* <Label id={PriorAuthorizationsConfig.buttonText} />{' '} */}
                    </Button>
                    {priorAuthError && priorAuthError['Error-'+index] && <Typography variant='body1'><span className='nopriorAuth'><Label id='noPriorAuthText'/>.</span></Typography>}
                  </div>
                </Card>
              </React.Fragment>
            );
          }))
         
        }
      </Container>
    </Box>
  );
};
export default PriorAuthorizations;
